import cn from 'classnames'
import React from 'react'

import { scrollProps } from 'services/Scroll/ScrollService'
import { AppMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getIsActiveNode } from 'services/Store/Project/selectors'

import type { IRowProps } from '../../Node/types'
import RowControls from '../../controls/RowControls'
import * as s from './EditorRow.module.scss'

const EditorRow: React.FC<IRowProps> = ({ children, node, block, style, mode }) => {
  const isActive = useProjectContext(getIsActiveNode, node.id)
  const isPro = mode.editorMode === AppMode.pro

  return (
    <div
      {...scrollProps(node.id)}
      className={cn(s.row, { [s.fillMode]: mode.editorMode === AppMode.fill })}
      style={style}
    >
      {children}
      {isPro && <RowControls block={block} isActive={isActive} nodeId={node.id} />}
    </div>
  )
}

export default React.memo(EditorRow)
